import { render, staticRenderFns } from "./FooterTrustPaymentMethods.vue?vue&type=template&id=543c9011"
import script from "./FooterTrustPaymentMethods.vue?vue&type=script&lang=js"
export * from "./FooterTrustPaymentMethods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports